import React from "react"
import { AppToolbarCreateButton } from "@components"

import { useUserSettingsTier } from "../@hooks"


export default function UserSettingTierTabButton() {
    const { handleSetTierFormData } = useUserSettingsTier()

    return <AppToolbarCreateButton
        label="Define Tier"
        onClick={handleSetTierFormData}
    />
}